<template>
  <div>
    <div class="flex items-center px-3 bg-[#f3f3f3] gap-3 h-[84px]">
      <button class="text-[#716f6f]" @click.prevent="$emit('close')">
        <SpriteSymbol name="close-2" class="size-3" />
      </button>
      <div class="size-[64px] rounded-[15px] overflow-hidden">
        <img width="480" height="480" src="~/assets/images/zt-app-icon.webp" />
      </div>
      <div class="text-black leading-snug">
        <div class="font-bold">Zürich City Guide</div>
        <div class="text-size-7">Zürich Tourism</div>
        <div class="text-size-7">
          {{ $texts('smartbanner.bottom', 'FREE - In Google Play') }}
        </div>
      </div>
      <a
        href="https://play.google.com/store/apps/details?id=com.zuerich.tourismus"
        target="_blank"
        class="ml-auto text-[#1474fc] text-[18px] p-3"
      >
        {{ $texts('smartbanner.button', 'View') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['close'])

const { $texts } = useEasyTexts()
</script>
